import {useEffect, useRef, useState} from 'react'
import {SActionBtn, SDrawerOrModal, SGeneralForms, SLowcodeList, SMessage, STableActions,} from 'shj-components'
import {config} from './config'
import {brandDelete, brandSave, brandUpdateById, brandUpdateState, getBrandPage,} from '@/services/product.ts'
import {apiData2Table, trimStr} from '@/utils/data.ts'
import {message, Switch} from 'antd'
import {isEmpty} from 'lodash-es'

export default function BrandManage() {
  const listRef = useRef()
  const formRef = useRef()
  const [open, setOpen] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [record, setRecord] = useState({})

  useEffect(() => {
    if (!isEmpty(record)) formRef.current?.onFormRef().setFieldsValue(record)
    return () => {
      formRef.current?.onFormRef().resetFields()
    }
  }, [record])

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      getBrandPage({
        params: {pageId: current, pageSize},
        data: {
          ...query
        },
      })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  const onAdd = () => onEdit()
  const onEdit = (record = {}) => {
    setOpen(true)
    setRecord(record)
  }

  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return brandDelete(id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onChangeStatus = (enabled: boolean, id: string) => {
    SMessage.confirm({
      title: `${enabled ? '打开' : '关闭'}开关，将${enabled ? '启用' : '禁用'}品牌，是否继续？`,
      okText: '继续',
      content: null,
      onOk: () => {
        return brandUpdateState({enabled, idList: [id]}).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onSubmit = () => {
    formRef.current
      ?.onFormRef()
      .validateFields()
      .then(values => {
        setBtnLoading(true)
        const apiUrl = values.id ? brandUpdateById : brandSave
        apiUrl({data: {...values}})
          .then((res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
            setOpen(false)
          })
          .finally(() => setBtnLoading(false))
      })
  }

  const extensions = {
    request: {fetchList},
    events: {
      onAdd,
    },
    status: {
      selectedDisabled: ({selectedRowKeys}: any) => !selectedRowKeys.length,
      radioDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      switchRender(v: boolean, record: Record<string, any>) {
        return (
          <Switch
            checkedChildren="启用"
            unCheckedChildren="禁用"
            checked={v}
            onClick={checked => onChangeStatus(checked, record.id)}
          />
        )
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onEdit(record)} auth="nodeConfigAdd">
              编辑
            </SActionBtn>
            <SActionBtn danger onClick={() => onDel(record.id)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
    },
  }

  return (
    <div>
      <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      <SDrawerOrModal
        title={(record.id ? '编辑' : '新增') + '品牌'}
        mode="modal"
        open={open}
        loading={btnLoading}
        onCancel={() => setOpen(false)}
        onOk={onSubmit}
        width={500}
      >
        <SGeneralForms
          ref={formRef}
          layout={'vertical'}
          configs={[
            {
              formItem: [
                {label: 'id', name: 'id', hidden: true},
                {
                  label: '名称',
                  name: 'name',
                  spanCol: 24,
                  required: true,
                  rules: [{required: true, message: '名称不能为空'}],
                  comConfig: {
                    showCount: true,
                    maxLength: 100,
                    onChange: e => onFormRef()?.setFieldValue('name', trimStr(e.target.value)),
                  },
                },
                {
                  label: '英文名',
                  name: 'code',
                  spanCol: 24,
                  comConfig: {
                    showCount: true,
                    maxLength: 50,
                    onChange: e => onFormRef()?.setFieldValue('code', trimStr(e.target.value)),
                  },
                },
              ],
            },
          ]}
        />
      </SDrawerOrModal>
    </div>
  )
}
